var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobspurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 148,
    viewBox: "0 0 402 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337.612 32.0244L305.418 32.7481L273.648 35.4621L290.592 25.6919L313.467 19.1784L307.113 10.132L279.155 5.97064L250.774 2.71394L221.545 0L191.893 0.180885H160.122L128.775 2.17112L99.5469 7.23716L116.915 17.5501L136.824 26.7775L155.463 36.1858L131.741 28.7677L103.359 23.8826L73.2834 23.1589L43.6312 27.3203L18.6384 35.2812L16.9442 45.2323L52.1032 47.2225L85.9916 51.3839L117.338 56.9927L89.3803 59.7066L60.1518 62.0587L30.4995 63.5061L0 64.4107L19.9094 76.3521L40.2424 87.9315L60.5753 99.3301L83.0263 110.186L106.324 120.68L131.317 130.45L158.004 139.496L185.962 148L194.434 135.878L204.601 124.298L214.767 112.9L244.843 116.518L275.766 119.232L306.689 120.861L338.036 122.489L369.383 123.575H400.306L401.153 108.015V92.6357V77.0758V61.5159V45.956L402 30.3961H368.959L337.612 32.0244Z",
    fill: "#AB1EBA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobspurple);
export default __webpack_public_path__ + "static/media/jobs(purple).f44a99dacd3270652191f6f48e441eea.svg";
export { ForwardRef as ReactComponent };